import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { NormalizedVariant } from '@ts/index';
import { ErrorBoundary } from '@components/utils';
import { FakeRecommendationCarousel } from '@components/common';
import { PRODUCT_TYPES, useTranslation } from '@utils/index';
import BaseFramePDPDetails from '../BaseFramePDPDetails';
import ProductView from '../ProductView';

type BaseFramePDPContentProps = {
	isStickySidebar: boolean;
	variant?: NormalizedVariant;
	name?: string;
	selectedMaterial?: string;
	journey?: string;
	selectedVariant?: NormalizedVariant;
	frame?: string;
	demo?: string;
};

const getTranslatedTexts = translator => {
	return {
		similarToProduct: (productName: string) => translator('similar-to-product', { productName }),
	};
};

export function BaseFramePDPContent({
	isStickySidebar,
	variant,
	name,
	selectedMaterial,
	journey,
	selectedVariant,
	frame,
	demo,
}: BaseFramePDPContentProps) {
	const { translator } = useTranslation();
	const translations = getTranslatedTexts(translator);
	const isSoldOutTreatment = useFeatureIsOn('is-sold-out-treatment');
	const isSoldOut = !variant?.availableForSale && isSoldOutTreatment;

	const Recommendations = () => (
		<ErrorBoundary>
			<FakeRecommendationCarousel
				variant={selectedVariant}
				selectedFrame={frame}
				headingText={translations.similarToProduct(name)}
				productTypes={[PRODUCT_TYPES.BASE_FRAME]}
				demo={demo}
				withPadding={isStickySidebar}
			/>
		</ErrorBoundary>
	);

	const components = {
		BaseFramePDPDetails: (
			<BaseFramePDPDetails
				journey={journey}
				selectedMaterial={selectedMaterial}
				padding={isStickySidebar ? 'small' : 'medium'}
			/>
		),
		Recommendations: <Recommendations />,
	};

	const layoutStategy = {
		soldOut: ['Recommendations', 'BaseFramePDPDetails'],
		default: ['BaseFramePDPDetails', 'Recommendations'],
	};

	const content = layoutStategy[isSoldOut ? 'soldOut' : 'default'].map(component => components[component]);
	return isStickySidebar ? content : <ProductView.Recommendations>{content}</ProductView.Recommendations>;
}
